export default function getYOffset(iTree, start, end) {
  const potentiallyOverlappingAnnotations = iTree.search(start, end);
  const potentialPositionsForNewAnnotation = potentiallyOverlappingAnnotations.map(() => true);
  potentiallyOverlappingAnnotations.forEach(function(otherAnnotation) {
    potentialPositionsForNewAnnotation[otherAnnotation.yOffset] = false;
  });
  const yOffset = potentialPositionsForNewAnnotation.indexOf(true);
  return yOffset > -1 ? yOffset : potentialPositionsForNewAnnotation.length;
}
